<template>
  <div class="device_wrap dialog-app-panel" :class="showDevicePanel ? 'dialog-show' : ''">
    <appPanel class="app-panel" :width="800" :isExpand="showDevicePanel" title="选择设备" @cancel="handleCloseDevicePanel">
      <div class="choose-device">
        <div v-for="(item, index) in checkDevice" class="device" :key="index">
          <el-tag size="small" @close="handleCloseTag(item)" closable>{{ item.deviceName }}</el-tag>
        </div>
      </div>
      <ioc-table ref="deviceMultipleTable" :data="tableData" :option="constData.deviceSelectTable" :page="constData.page"
        @selection-change="handleSelectionChange" @search-change="handleSearchChange" @search-reset="handleSearchReset"
        @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </ioc-table>

      <div slot="footer" class="dialog-footer" style="margin-bottom: 18px;">
        <el-button @click="handleCloseDevicePanel" type="info" :loading="subLoading">
          {{ subLoading ? "提交中" : "取消" }}
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSaveDevicePanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </div>
    </appPanel>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index";
import utils from "@src/common/utils";
import { api } from "../api/index";
import { deviceSelectTable } from "../config/deviceSelectTable";
export default {
  name: 'deviceSelectByType',
  components: {
    appPanel,
  },
  props: {
    showDevicePanel: {
      type: Boolean,
      default: false,
    },
    selectGroup: {
      type: String,
      default: "",
    },
  },
  watch: {
    showDevicePanel: {
      handler(val) {
        if (val) {
          // this.constData.page.pageNum = 1;
          // this.constData.page.pageSize = utils.Cache.get("CURRENT_PAGESIZE") || 10;
          this.$set(this.constData, 'page', {
            pageNum: 1,
            pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
          })
          this.getDevice();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      constData: {
        deviceSelectTable: deviceSelectTable(),
        page: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        searchForm: {},
      },
      tableData: [],
      checkDevice: [],
      subLoading: false,
    };
  },
  created() { },
  mounted() { },
  methods: {
    handleCloseDevicePanel() {
      this.checkDevice = [];
      this.$emit("handleCloseDevicePanel");
    },
    getDevice() {
      let params = {
        ...this.constData.page,
        ...this.constData.searchForm,
        personnelMark: this.selectGroup,
        whether: 0 // 0 不包含 0 不包含
      };
      this.$fetch(api.type.queryTypeDevice, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.tableData = res.returnObj.list;
        this.constData.page.total = res.returnObj.total;
      });
    },
    handleSaveDevicePanel() {
      if (!this.checkDevice.length) {
        this.$message.warning("请选择设备");
        return;
      }
      let params = {
        devices: this.checkDevice.map((el) => {
          return {
            deviceId: el.deviceId,
            thirdDeviceId: el.thirdDeviceId
          };
        }),
        personnelMark: this.selectGroup
      };
      this.subLoading = true;
      this.$fetch(api.type.addTypeDevice, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.handleCloseDevicePanel();
        } else {
          this.$message.error(res.msgContent || "添加失败");
        }
        //
      });
    },
    handleSearchChange(param) {
      this.constData.page.pageNum = 1;
      this.constData.searchForm = Object.assign({}, param);
      this.getDevice();
    },
    // 条件重置
    handleSearchReset() {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = 10;
      this.constData.searchForm = {};
      this.getDevice();
    },
    // 分页查询
    handleCurrentChange(val) {
      this.constData.page.pageNum = val;
      this.getDevice();
    },
    // 条数查询
    handleSizeChange(val) {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = val;
      this.getDevice();
    },
    // 多选
    handleSelectionChange(row) {
      this.checkDevice = [...row];
    },
    handleCloseTag(item) {
      this.$refs.deviceMultipleTable.$refs.multipleTable.toggleRowSelection(
        item,
        false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.device_wrap {
  width: 100%;
  height: 100%;

  .choose-device {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;

    .device {
      margin: 0px 5px 5px;
    }
  }
}
</style>